window?.addEventListener('DOMContentLoaded', function () {
  const featuredProducts = document?.querySelectorAll(
    '.featured-product-section',
  );

  featuredProducts?.forEach((item) => {
    const sliderEl = item?.querySelector('.keen-slider');
    const prevBtn = item?.querySelector('.prev-btn');
    const nextBtn = item?.querySelector('.next-btn');
    const threeSlidesPerView = item?.classList?.contains(
      'three-slides-per-view',
    );
    if (sliderEl) {
      const slider = new KeenSlider(sliderEl, {
        breakpoints: {
          '(max-width: 1400px)': {
            slides: { perView: threeSlidesPerView ? 3 : 4, spacing: 10 },
          },
          '(max-width: 1280px)': {
            slides: { perView: 3, spacing: 10 },
          },
          '(max-width: 1024px)': {
            slides: { perView: 2, spacing: 10 },
          },
          '(max-width: 640px)': {
            slides: { perView: threeSlidesPerView ? 1 : 2, spacing: 10 },
          },
        },
        slides: {
          perView: threeSlidesPerView ? 3 : 4,
          spacing: 32,
        },
        created(e) {
          updateButtons(e);
        },
        slideChanged(e) {
          updateButtons(e);
          updateDots();
        },
      });
      const dotsContainer = item?.querySelector('.dots-container');
      let dots = [];

      function createDots() {
        if (!dotsContainer) return;
        const slidesCount = slider?.track?.details?.slides?.length;
        dotsContainer.innerHTML = '';
        for (let i = 0; i <= slidesCount - 1; i++) {
          const dot = document.createElement('button');
          dot.className = 'dot';
          dot.setAttribute('aria-label', 'dot');
          dot.addEventListener('click', () => slider.moveToIdx(i));
          dotsContainer.appendChild(dot);
          dots.push(dot);
        }
        updateDots();
      }

      function updateDots() {
        if (!dots?.length) return;
        const currentIdx = slider?.track?.details?.rel;
        dots.forEach((dot, idx) => {
          dot?.classList?.toggle('active', idx === currentIdx);
        });
      }

      createDots();

      function updateButtons(slider) {
        const details = slider.track.details;

        if (!details) return;

        const isFirst = details.rel === 0;
        const isLast = details.rel >= details.maxIdx;

        if (isFirst) {
          prevBtn?.classList.add('disabled');
        } else {
          prevBtn?.classList.remove('disabled');
        }

        if (isLast) {
          nextBtn?.classList.add('disabled');
        } else {
          nextBtn?.classList.remove('disabled');
        }
      }

      prevBtn?.addEventListener('click', () => slider.prev());
      nextBtn?.addEventListener('click', () => slider.next());
    }
  });
});
